/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Campaign_ClosedInputs */

const en_error_sales_campaign_closed = /** @type {(inputs: Error_Sales_Campaign_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sales campaign already started or is archived.`)
};

/**
* | output |
* | --- |
* | "This sales campaign already started or is archived." |
*
* @param {Error_Sales_Campaign_ClosedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_campaign_closed = /** @type {((inputs?: Error_Sales_Campaign_ClosedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Campaign_ClosedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_campaign_closed(inputs)
});